import { Button } from 'antd';
import calendarPng from 'assets/images/calendar.png';
import arrowPng from 'assets/images/arrow-blue.png';
import { useEffect, useState } from 'react';
import ModalEndSubmit from '../../../Organisms/Modals/ModalEndSubmit/ModalEndSubmit';
import { TaskState } from '../../../../../../gql/graphql';
import StateTag from '../../Tags/StateTag/StateTag';
import InputUploadedFile from '../../Inputs/InputUploadedFile/InputUploadedFile';
import UploadDocs from '../../UploadDocs/UploadDocs';
import InputBorderNone from '../../Inputs/InputBorderNone/InputBorderNone';
import ErrorBox from '../../../../../Atoms/Alerts/ErrorBox';
import { LimitFiles } from 'scenes/Private/LoanDetails/LoanDocuments/constants';
import { useFileUploadSync } from '../../../../../../@common/utils/hooks/useFileUploadSync';

interface Props {
  title: string;
  titleLocation?: 'outside' | 'inside' | undefined;
  description?: string;
  isButtonSample?: { show: boolean; link: string };
  isButtonTemplate?: { show: boolean; link: string };
  isDescriptionButton?: { show: boolean; name: string; link: string };
  submit?: {
    title: string;
    confirmDescription?: string;
    modalConfirm?: boolean;
    loading: boolean;
    onClick: (files: File[], metadata?: any) => void;
    location?: 'outside' | 'inside' | undefined;
    disabled?: boolean;
    hidden?: boolean;
  };
  isCreditReportDocument?: boolean;
  isLoanDoc?: any;
  hasDropdown?: boolean;
  limitFiles?: number;
  files?: File[] | any;
  state?: TaskState;
  hiddenTagDraft?: boolean;
  actionDeleteFile?: any;
  onChangeFiles?: any;
  insertHtml?: any;
  onDeleteFile?: boolean;
  messageErrorDisabled?: string | string[];
  isSelectChanged?: boolean;
  errorMessage?: string;
  uploadQueueFiles?: any[];
  uploadQueue?: any;
}

const CardUploadResponse = ({
  title,
  titleLocation,
  description,
  isButtonSample,
  isButtonTemplate,
  submit,
  isCreditReportDocument,
  isLoanDoc,
  hasDropdown = false,
  limitFiles = 1,
  files,
  state,
  actionDeleteFile,
  onChangeFiles,
  hiddenTagDraft,
  insertHtml,
  onDeleteFile,
  messageErrorDisabled,
  isSelectChanged,
  isDescriptionButton,
  errorMessage,
  uploadQueueFiles = [],
  uploadQueue,
}: Props) => {

  const [isModalSubmit, setModalSubmit] = useState(false);

  // ✅ TODA LA LÓGICA DE SINCRONIZACIÓN EN UNA LÍNEA
  const { enrichedFiles, setListFileUpload } = useFileUploadSync({
    files,
    uploadQueueFiles,
    allowContinuousUpload: limitFiles === LimitFiles.MULTIPLE_FILES,
    uploadQueue,
    onChangeFiles
  });

  const [creditScore, setCreditScore] = useState<string | null>(null);
  const [orderedDate, setOrderedDate] = useState<Date | null>(null);
  const [expiryDate, setExpiryDate] = useState<Date | null>(null);
  const [editableFields, setEditableFields] = useState({
    creditScore: false,
    orderedDate: false
  });
  const [showErrorBox, setShowErrorBox] = useState(false);

  const savedFiles = files?.filter((item: any) => item.url || item.key) || [];
  const allowContinuousUpload = limitFiles === LimitFiles.MULTIPLE_FILES;

  useEffect(() => {
    if (isCreditReportDocument && isLoanDoc?.metadata) {
      setCreditScore(isLoanDoc?.metadata?.creditScore ?? null);
      setOrderedDate(isLoanDoc?.metadata?.orderedDate ? new Date(isLoanDoc?.metadata?.orderedDate) : null);
      setExpiryDate(isLoanDoc?.metadata?.expiryDate ? new Date(isLoanDoc?.metadata?.expiryDate) : null);
    }
  }, [isLoanDoc, isCreditReportDocument]);

  useEffect(() => {
    if (orderedDate) {
      const newDate = new Date(orderedDate);
      newDate.setDate(newDate.getDate() + 90);
      setExpiryDate(newDate);
    }
  }, [orderedDate]);

  useEffect(() => {
    if(onDeleteFile) setListFileUpload([]);
  }, [onDeleteFile, setListFileUpload]);

  const onSubmit = () => {
    if (submit?.modalConfirm) setModalSubmit(true);
    else submit?.onClick(enrichedFiles);
  };

  useEffect(() => {
    if(isSelectChanged && !submit?.disabled) setShowErrorBox(false);
  });

  return (
    <>
      {titleLocation === 'outside' &&
        <span className="h4">{title}</span>
      }
      <div
        className={`card-upload-response card-upload-response-${state}`}
        style={{ marginTop: titleLocation === 'outside' ? 10 : 0 }}
      >
        {insertHtml}

        {state && (state !== TaskState.Review && !hiddenTagDraft) && <StateTag state={state} />}
        {state && (state === TaskState.Review) && <StateTag state={state} isLabelLocked />}

        {(title || isButtonSample) &&
          <div className="header" style={{ marginTop: !isButtonSample ? 10 : 0 }}>
            {!titleLocation && <span className="h4">{title}</span>}
            {isButtonSample?.show && (
              <Button type="link" className="link">
                See sample
              </Button>
            )}
          </div>
        }
        <div className="description">
          {description} {' '}
          {isDescriptionButton?.show && (
            <Button type="link" className="link description-button-link" onClick={() => window.open(isDescriptionButton?.link, '_blank')}>
              {isDescriptionButton?.name}
            </Button>
          )}
        </div>
        {isButtonTemplate?.show && (
          <div className="template">
            <Button type="link" className="button button-blue" onClick={() => window.open(isButtonTemplate.link, '_blank')}>
              Download template
            </Button>
            <img src={arrowPng} className="arrow-right" alt="arrow" />
          </div>
        )}
        <div className="section-upload">
          {savedFiles.length > 0 && !allowContinuousUpload && (
            <div className="cont-files">
              {savedFiles?.filter((item: any) => item.state !== 'request_error').map((file: any, index: number) => (
                <InputUploadedFile
                  key={index}
                  file={file}
                  isActionSeeFile
                  state={state ? file.state : null}
                  deleteFile={actionDeleteFile}
                  uploadStatus={file.uploadStatus}
                  errorMessage={file.errorMessage}
                  onRetry={file.onRetry}
                />
              ))}
            </div>
          )}

          {(
            (!allowContinuousUpload && savedFiles.length === 0) ||
            (allowContinuousUpload && enrichedFiles.length < limitFiles) ||
            state === TaskState.RequestError
          ) && (
            <UploadDocs
              numberOfFiles={limitFiles}
              button={
                submit && (!submit.location || submit.location === 'inside') ? (
                  <Button
                    className="button button-submit"
                    loading={submit.loading}
                    disabled={enrichedFiles.length === 0 || submit.disabled}
                    onClick={onSubmit}
                  >
                    {submit.title}
                  </Button>
                ) : null
              }
              onDeleteFile={actionDeleteFile}
              listFileUpload={enrichedFiles}
              setListFileUpload={setListFileUpload}
              uploadQueueFiles={uploadQueueFiles}
            />
          )}
        </div>

        {!submit?.hidden && submit?.modalConfirm && (
          <ModalEndSubmit
            visible={isModalSubmit}
            setVisible={setModalSubmit}
            buttonAction={{
              hidden: true
            }}
            modal={{
              title: 'Ready to submit?',
              description: submit?.confirmDescription ? (
                <h4 className="h4 h4-w4">{submit?.confirmDescription}</h4>
              ) : undefined
            }}
            buttonSubmit={
              <Button
                className="button button-modal-ok"
                onClick={() => {
                  setModalSubmit(false);
                  !isCreditReportDocument ? submit.onClick(enrichedFiles) // ✅ enrichedFiles
                  :
                  submit.onClick(enrichedFiles, { // ✅ enrichedFiles
                    creditScore,
                    orderedDate,
                    expiryDate
                  })
                }}
                loading={submit.loading}
              >
                Yes, this is correct
              </Button>
            }
            buttonCancel={(actionCancel: any) => (
              <Button
                className="button button-modal-cancel"
                onClick={actionCancel}
              >
                I want to make changes
              </Button>
            )}
            icon={calendarPng}
            className="modal-end-submit--white"
          />
        )}
      </div>
      {isCreditReportDocument && (
        <div className='mt-20'>
          <InputBorderNone
            type='edit-number'
            label={'Credit Score'}
            placeholder='55'
            color='bold'
            value={creditScore}
            disabled={!editableFields.creditScore}
            onChange={(val: string) =>
              setCreditScore(
                val.replace(/\D/g, '').replace(/(\d{3})(?=\d)/g, '$1-')
              )
            }
            canEdit={!submit?.disabled}
            onEditClick={() => 
              setEditableFields((prev) => ({ ...prev, creditScore: !prev.creditScore}))
            }
          />
          <InputBorderNone
            type='edit-date'
            label={'Latest Credit Report Ordered Date'}
            placeholder=''
            color='bold'
            value={orderedDate}
            disabled={!editableFields.orderedDate}
            onChange={(date: Date) => setOrderedDate(date)}
            canEdit={!submit?.disabled}
            onEditClick={() => {
              setEditableFields((prev) => ({ ...prev, orderedDate: !prev.orderedDate}))
            }}
          />
          <InputBorderNone
            type='edit-date'
            label={'Credit Report Expiry'}
            placeholder=''
            color='bold'
            value={expiryDate}
            disabled
          />
        </div>
      )}
      {!submit?.hidden && submit?.location === 'outside' && (
        <div className="mt-20" style={{ position: 'relative' }}>
          <Button
            className="button button-submit"
            loading={submit?.loading}
            disabled={
              (!hasDropdown && enrichedFiles.length === 0) || submit.disabled}
            onClick={onSubmit}
          >
            {submit?.title}
          </Button>
          {(!hasDropdown && enrichedFiles.length === 0) || submit.disabled && hasDropdown && (
            <div
              onClick={() => setShowErrorBox(true)}
              style={{
                position: 'absolute',
                top: 0,
                left: 0,
                width: '100%',
                height: '100%',
                cursor: 'not-allowed',
                backgroundColor: 'transparent'
              }}
            />
          )}
          {showErrorBox && messageErrorDisabled && hasDropdown && (
            <>
              {Array.isArray(messageErrorDisabled) ? (
                messageErrorDisabled.map((msg, index) => {
                  const isDropdownError = msg.includes('Confirm dropdown status');
                  const shouldShow = isDropdownError ? !isSelectChanged : true;
                  return shouldShow ? (
                    <ErrorBox key={index} text={msg} className='mt-10' />
                  ) : null;
                })
              ) : (
                !isSelectChanged && <ErrorBox text={messageErrorDisabled} className='mt-10' />
              )}
            </>
          )}
          {errorMessage && (
            <ErrorBox text={errorMessage} className='mt-10' />
          )}
        </div>
      )}
    </>
  );
};
export default CardUploadResponse;
